import React from "react";

export type ButtonsAlign = "left" | "center" | "right" | "justify";
export type LabelVisibility = "placeholder" | "small" | "edge";
export type FormStyleContextProps = {
  buttonsAlign?: ButtonsAlign;
  fieldStyle?: React.CSSProperties;
  labelPosition?: "inside" | "top";
  labelVisibility?: LabelVisibility;
  labelStyle?: React.CSSProperties;
  primaryButtonStyle?: React.CSSProperties;
  secondaryButtonStyle?: React.CSSProperties;
};

export const FormStyleContext = React.createContext<FormStyleContextProps>({});
